import React, { useState } from "react";
import PropTypes from "prop-types";
// I18n
import { useTranslation } from "react-i18next";
import { Grid, Paper, Typography, Button } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { Delete } from "@material-ui/icons";
import "date-fns";
import moment from "moment";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useHistory, useLocation } from "react-router-dom";
import {
  ACTIVITIES,
  ALL_ACTIVITIES,
  REPORTS,
  REVIEW,
} from "../../../../navigation/CONSTANTS";

// components
import Confirmation from "../../../../components/Confirmation";
import SectionHead from "../../../../components/SectionHead";
import Styles from "./style";
import LastPunchStatus from "components/LastPunchStatus";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { SET_EMPTY } from "config";
import { isEmptyObject } from "../../../../utils/index";
import ConfirmDialog from "components/ConfirmDialog";

import AccessTimeIcon from "@material-ui/icons/AccessTime";

import Employee from "../../../../components/Employee";

import { getEmployeeNameWithID } from "../../../../utils/index";
import { PROJECT } from "config";

export const AddEditPunchView = (props) => {
  const classes = Styles();
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const { user, pageTitle, workers, employeeChange } = props;
  // const { punch, punchOptions, punchChange } = props;
  const { activityStartDate, activityStartDateChange } = props;
  const { activityStartTime, activityStartTimeChange } = props;
  const { activityEndDate, activityEndDateChange } = props;
  const { activityEndTime, activityEndTimeChange } = props;
  const { jobFamily, jobFamiliesOptions, jobFamilyChange } = props;
  const { activityGroup, activityGroupOptions, activityGroupChange } = props;
  const { district, districtOptions, districtChange } = props;
  const { building, buildingOptions, buildingChange } = props;
  const { exception, exceptionOptions, exceptionChange } = props;
  const { saveHandler, cancelHandler, deleteHandler } = props;
  const { project, projectOptions, projectGroupHandler } = props;
  const {
    specialProjectDialog,
    specialProject,
    handleChangeSpecialProject,
    isDisabledSpecialProjectOK,
    okSpecialProjectDialog,
    cancelSpecialProjectDialog,
    jobProjectInfoLabel,
    jobProjectInfoVisible,
    errProjectInfoEntry,
    customerSite,
    errCustomerSite,
    customerSiteVisible,
    customerSiteChange,
  } = props;
  const {
    confirmationMsg,
    closeModalConfirmationMsg,
    confirmationMsgText,
    confirmationTitleText,
  } = props;

  const { back, disableSave } = props;

  const { lastPunch } = props;
  const { currentPunch } = props;
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "pgPunch.tlConfirmation",
    subTitle: "pgReview.msgDeletePunch",
  });
  const [confirmationBox, setConfirmationBox] = useState({
    isOpen: false,
    title: t("pgPunch.tlConfirmation"),
    subTitle: t("pgReview.msgDeleteSuccess"),
  });
  let JFOptions = [];
  const onDelete = (punch) => {
    setConfirmDialog({ ...confirmDialog, isOpen: false });
    deleteHandler(punch);
  };

  const deleteDone = () => {
    setConfirmationBox({ ...confirmationBox, isOpen: false });
    location.state.isAllPunch
      ? history.push(ALL_ACTIVITIES, { isAllPunchView: true })
      : location.state.isReport
      ? history.push(REPORTS, { isReportView: true })
      : //: history.push(ACTIVITIES);
        history.goBack();
  };

  return (
    <>
      <Grid container direction="row" justify="center">
        <Grid item sm={7} xs={12}>
          <Paper elevation={3} className={classes.card}>
            <SectionHead back={back} name={pageTitle} />
            {!workers && user && (user.firstName || user.lastName) && (
              <Grid container direction="row">
                <Grid item xs={9}>
                  <Employee user={user} />
                </Grid>

                {lastPunch && (
                  <Grid item xs={3}>
                    <LastPunchStatus lastPunch={lastPunch}></LastPunchStatus>
                  </Grid>
                )}
              </Grid>
            )}

            {workers && (
              <Grid container direction="row">
                <Grid item xs={6} sm={6}>
                  <FormControl className={classes.formControl}>
                    <Autocomplete
                      options={workers}
                      getOptionLabel={(option) =>
                        option && (option.firstName || option.lastName)
                          ? getEmployeeNameWithID(option)
                          : SET_EMPTY
                      }
                      id="employeeSearch"
                      disableClearable
                      classes={{ inputRoot: classes.color }}
                      size="small"
                      InputProps={{ className: classes.color }}
                      onChange={employeeChange}
                      defaultValue={workers[0]}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t("other.lblWorker")}
                          FormHelperTextProps={{
                            className: classes.formHelperText,
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            )}

            {/* activity start date and time ---week disabling...future dates disabling */}
            <Grid container direction="row">
              <Grid item xs={12} sm={6} md={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    disableBackdropClick
                    margin="normal"
                    id="date-picker-dialog"
                    label={t("pgAddEditPunchSupervisor.lblActStartDate")}
                    format="dd/MM/yyyy"
                    value={activityStartDate}
                    onChange={activityStartDateChange}
                    minDate={moment().day(-14)}
                    maxDate={moment().day(20)}
                    KeyboardButtonProps={{
                      "aria-label": "Select Punch Date",
                    }}
                    className={classes.formControl}
                    invalidDateMessage={t(
                      "pgAddEditPunchSupervisor.lblInvalidDate"
                    )}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardTimePicker
                    ampm={false}
                    disableBackdropClick
                    margin="normal"
                    id="time-picker"
                    label={t("pgAddEditPunchSupervisor.lblActStartTime")}
                    value={activityStartTime}
                    onChange={activityStartTimeChange}
                    KeyboardButtonProps={{
                      "aria-label": "Select Punch Time",
                    }}
                    className={classes.formControl}
                    invalidDateMessage={t(
                      "pgAddEditPunchSupervisor.lblInvalidTime"
                    )}
                    keyboardIcon={<AccessTimeIcon />}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
            </Grid>

            {/* activity end date and time */}
            <Grid container direction="row">
              <Grid item xs={12} sm={6} md={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    disableBackdropClick
                    margin="normal"
                    id="date-picker-dialog"
                    label={t("pgAddEditPunchSupervisor.lblActEndDate")}
                    format="dd/MM/yyyy"
                    value={activityEndDate}
                    onChange={activityEndDateChange}
                    minDate={new Date(activityStartDate)}
                    maxDate={moment().day(20)}
                    KeyboardButtonProps={{
                      "aria-label": "Select Punch Date",
                    }}
                    minDateMessage={t("pgPunch.minDateErrorMessage")}
                    className={classes.formControl}
                    invalidDateMessage={t(
                      "pgAddEditPunchSupervisor.lblInvalidDate"
                    )}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardTimePicker
                    ampm={false}
                    disableBackdropClick
                    margin="normal"
                    id="time-picker"
                    label={t("pgAddEditPunchSupervisor.lblActEndTime")}
                    value={activityEndTime}
                    onChange={activityEndTimeChange}
                    KeyboardButtonProps={{
                      "aria-label": "Select Punch Time",
                    }}
                    className={classes.formControl}
                    invalidDateMessage={t(
                      "pgAddEditPunchSupervisor.lblInvalidTime"
                    )}
                    keyboardIcon={<AccessTimeIcon />}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
            </Grid>

            {/* District and Building */}
            <Grid container direction="row">
             

              <Grid item xs={6} sm={6}>
                <FormControl className={classes.formControl}>
                  <InputLabel id="district-label">
                    {t("pgPunch.lblDistrict")}
                  </InputLabel>
                  <Select
                    labelId="district-label"
                    id="district-select"
                    value={district}
                    onChange={districtChange}
                  >
                    {districtOptions && districtOptions.map((item, idx) => (
                      <MenuItem key={idx} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={6}>
                <FormControl className={classes.formControl}>
                  <InputLabel id="building-label">
                    {t("pgPunch.lblBuilding")}
                  </InputLabel>
                  <Select
                    labelId="building-label"
                    id="building-select"
                    value={building}
                    onChange={buildingChange}
                  >
                    {(user && user.isApprover
                      ? buildingOptions
                      : buildingOptions.filter((item) => !item.mgrOnly)
                    ).map((item, idx) => (
                      <MenuItem key={idx} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            {customerSiteVisible && (
              <Grid container direction="row">
                <Grid item xs={6} sm={6}>
                  <FormControl className={classes.formControl}>
                    <TextField
                      // multiline
                      autoFocus
                      id="customer-site-details"
                      label={t("pgPunch.phCustomerSite")}
                      type="text"
                      fullWidth
                      value={customerSite}
                      onChange={customerSiteChange}
                      placeholder={t("pgPunch.subTextCustomerSite")}
                      error={errCustomerSite}
                      inputProps={{ maxLength: 100 }}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            )}

            {/* district and ACTIVITY_GROUP */}
            <Grid container direction="row">
              

              <Grid item xs={6} sm={6}>
                <FormControl className={classes.formControl}>
                  <InputLabel id="job-family-label">
                    {t("pgPunch.lblJobFamily")}
                  </InputLabel>
                  <Select
                    labelId="job-family-label"
                    id="job-family-select"
                    value={jobFamily}
                    onChange={jobFamilyChange}
                    disabled={(activityGroup === "Leave"||activityGroup === "Meal") ? true : false}
                  >
                    {
                      ((JFOptions =
                        user && user.isApprover
                          ? jobFamiliesOptions
                          : jobFamiliesOptions.filter((item) => !item.mgrOnly)),
                      JFOptions.map((item, idx) => (
                        <MenuItem key={idx} value={item.value}>
                          {item.label}
                        </MenuItem>
                      )))
                    }
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6} sm={6}>
                <FormControl className={classes.formControl}>
                  <InputLabel id="activity-group-label">
                    {t("pgPunch.lblActivityGroup")}
                  </InputLabel>
                  <Select
                    labelId="activity-group-label"
                    id="activity-group-select"
                    value={activityGroup}
                    onChange={activityGroupChange}
                  >
                    {/* {console.log("activity group value", activityGroup)}
                    {console.log("job family value", jobFamily)} */}
                    {activityGroupOptions.map((item, idx) => (
                      <MenuItem key={idx} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            {/*  exception */}
            <Grid container direction="row">
              {projectOptions.length > 1 ? (
                <Grid item xs={6} sm={6}>
                  <FormControl className={classes.formControl}>
                    <InputLabel id="activity-name-label">
                      {activityGroup === "Leave"
                        ? "Leave Type"
                        : activityGroup === PROJECT
                        ? t("other.phJobProjectInfo")
                        : t("other.lblActivityName")}
                    </InputLabel>

                    <Select
                      labelId="activity-name-label"
                      id="activity-name-select"
                      value={project}
                      onChange={projectGroupHandler}
                      disabled={activityGroup === "Meal"?true:false}
                    >
                      {projectOptions.map((item, idx) => (
                        <MenuItem key={idx} value={item.value}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              ) : (
                activityGroup !== -1 &&
                jobProjectInfoVisible && (
                  <Grid item xs={6} sm={6}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        autoFocus
                        id="sp"
                        label={
                          activityGroup === "Leave"
                            ? "Leave Type"
                            : activityGroup === PROJECT
                            ? t("other.phJobProjectInfo")
                            : t("other.lblActivityName")
                        }
                        type="text"
                        fullWidth
                        value={jobProjectInfoLabel}
                        onChange={handleChangeSpecialProject}
                        placeholder={
                          activityGroup === "Leave"
                            ? "Leave Type"
                            : activityGroup === PROJECT
                            ? t("other.phJobProjectInfo")
                            : t("other.lblActivityName")
                        }
                        inputProps={{ maxLength: 100 }}
                        //      error={errProjectInfoEntry}
                        disabled={activityGroup==="Meal"?true:false}
                      />
                    </FormControl>
                  </Grid>
                )
              )}

              <Grid item xs={6} sm={6}>
                <FormControl className={classes.formControl}>
                  <InputLabel id="exception-label">
                    {/* {t('pgPunch.lblBuilding')} */} Exception
                  </InputLabel>
                  <Select
                    labelId="exception-label"
                    id="exception-select"
                    value={exception}
                    onChange={exceptionChange}
                  >
                    {exceptionOptions.map((item, idx) => (
                      <MenuItem key={idx} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            {/* save and cancel buttons */}
            <Grid container alignItems="flex-end" justify="space-between">
              <Grid item>
                {!workers &&
                  user &&
                  !isEmptyObject(currentPunch) &&
                  currentPunch && (
                    <Button
                      style={{ backgroundColor: "#f44336", color: "#fff" }}
                      variant="contained"
                      onClick={() => {
                        setConfirmDialog({
                          ...confirmDialog,
                          isOpen: true,
                          onConfirm: () => {
                            onDelete(currentPunch);
                          },
                        });
                      }}
                    >
                      {t("pgReview.btnDelete")}
                    </Button>
                  )}
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={cancelHandler}
                  className={classes.button}
                >
                  {t("general.cancelBtn")}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={saveHandler}
                  className={classes.button}
                  disabled={disableSave}
                >
                  {t("general.saveBtn")}
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>

      <Dialog
        open={specialProjectDialog}
        aria-labelledby="special-project-dialog"
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle id="form-dialog-title">{jobProjectInfoLabel}</DialogTitle>
        <DialogContent>
          <TextField
            // multiline
            autoFocus
            id="sp"
            label="Details"
            type="text"
            fullWidth
            value={specialProject}
            onChange={handleChangeSpecialProject}
            placeholder="Enter Characters"
            helperText="Enter 0 if not applicable"
            inputProps={{ maxLength: 100 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelSpecialProjectDialog} color="primary">
            Cancel
          </Button>
          <Button
            onClick={okSpecialProjectDialog}
            color="primary"
            disabled={isDisabledSpecialProjectOK}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Confirmation
        confirmationMsg={confirmationMsg}
        closeModalConfirmationMsg={closeModalConfirmationMsg}
        confirmationMsgText={confirmationMsgText}
        confirmationTitleText={confirmationTitleText}
      />
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
      <Confirmation
        confirmationMsg={confirmationBox.isOpen}
        closeModalConfirmationMsg={deleteDone}
        confirmationMsgText={confirmationBox.subTitle}
        confirmationTitleText={confirmationBox.title}
      />
    </>
  );
};

AddEditPunchView.propTypes = {
  user: PropTypes.object,
  pageTitle: PropTypes.string,
  workers: PropTypes.object,
  employeeChange: PropTypes.func,
  punch: PropTypes.any,
  punchOptions: PropTypes.any,
  punchChange: PropTypes.func,
  activityStartDate: PropTypes.any,
  activityStartDateChange: PropTypes.any,
  activityStartTime: PropTypes.any,
  activityStartTimeChange: PropTypes.any,
  activityEndDate: PropTypes.any,
  activityEndDateChange: PropTypes.func,
  activityEndTime: PropTypes.any,
  activityEndTimeChange: PropTypes.func,
  jobFamily: PropTypes.any,
  jobFamiliesOptions: PropTypes.any,
  jobFamilyChange: PropTypes.func,
  activityGroup: PropTypes.any,
  activityGroupOptions: PropTypes.any,
  activityGroupChange: PropTypes.func,
  district: PropTypes.any,
  districtOptions: PropTypes.any,
  districtChange: PropTypes.func,
  building: PropTypes.any,
  buildingOptions: PropTypes.any,
  buildingChange: PropTypes.func,
  exception: PropTypes.any,
  exceptionOptions: PropTypes.any,
  exceptionChange: PropTypes.func,
  saveHandler: PropTypes.func,
  cancelHandler: PropTypes.func,
  deleteHandler: PropTypes.func,
  specialProjectDialog: PropTypes.any,
  specialProject: PropTypes.any,
  handleChangeSpecialProject: PropTypes.any,
  isDisabledSpecialProjectOK: PropTypes.any,
  okSpecialProjectDialog: PropTypes.any,
  cancelSpecialProjectDialog: PropTypes.any,
  jobProjectInfoLabel: PropTypes.any,
  jobProjectInfoVisible: PropTypes.any,
  errProjectInfoEntry: PropTypes.any,
  customerSite: PropTypes.any,
  errCustomerSite: PropTypes.any,
  customerSiteVisible: PropTypes.any,
  customerSiteChange: PropTypes.func,
  confirmationMsg: PropTypes.any,
  confirmationBox: PropTypes.any,
  closeModalConfirmationMsg: PropTypes.any,
  confirmationMsgText: PropTypes.any,
  confirmationTitleText: PropTypes.any,
  back: PropTypes.func,
  disableSave: PropTypes.bool,
  lastPunch: PropTypes.any,
  currentPunch: PropTypes.any,
};

export default AddEditPunchView;
